export enum NotificationMode {
    WARN = 'warn',
    DANGER = 'danger',
    INFO = 'info',
    SUCCESS = 'success',
}
